module.exports = __webpack_public_path__ + "static/img/glove_poil_chameau.53f799f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_poil_chameau.png
// module id = FFOP
// module chunks = 0